import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Imagem from 'Component/Imagem';
import Empresa from 'Interface/Empresas';
import { useEditarEmpresaMutation } from 'View/Service/Default/Empresas';

interface Props {
  dados: Empresa;
  acoes?: boolean;
}

const Lista = ({ dados, acoes = true }: Props): React.ReactElement => {
  const toast = useToast();
  const [editarEmpresa] = useEditarEmpresaMutation();

  const remover = async (): Promise<void> => {
    try {
      await editarEmpresa({ id: dados.id, ativo: false }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div
      key={dados.nome_fantasia}
      className="d-flex border-bottom align-items-center py-2 px-3"
    >
      <Link to={`/empresas/editar/${dados.id}`}>
        <Imagem
          src={dados.imagem}
          alt={dados.nome_fantasia}
          className="rounded-circle object-fit-cover"
          width="80"
          height="80"
        />
      </Link>
      <div className="ms-4 fs-4">
        <Link
          to={`/empresas/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.nome_fantasia}
        </Link>
        <small className="d-block fs-6 text-muted">{dados.razao_social}</small>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end">
        <div className="ms-5 fs-5 text-end">
          {dados.cnpj}
          <small className="d-block fs-6 text-muted">CNPJ</small>
        </div>
        <div className="ms-5 fs-5 text-end">
          {dados.criado.data().toLocaleString()}
          <small className="d-block fs-6 text-muted">Criado em</small>
        </div>
        <div className="fs-5 text-end">
          {acoes && (
            <Botao
              icone="trash"
              tema="danger"
              className="ms-5"
              confirmacao="Você tem certeza que deseja remover essa empresa? Essa ação é irreversivel."
              onClick={remover}
            />
          )}
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
